/*
 * air-compression-pro.js — native behaviour for the converted pulsio-eu
 * Compression PRO product page. Replaces the deleted Replo runtime for exactly
 * the interactions this page uses:
 *   1. Carousels (prev/next, dots, pointer drag) — transform based.
 *   2. Collapsibles / accordions (data-replo-collapsible).
 *   3. Variant (size) option-select -> keeps the hidden cart form in sync.
 *   4. Add-to-cart buttons (data-replo-add-product-variant-to-cart) -> AJAX
 *      /cart/add.js with bundled sections, then Impact theme variant:add /
 *      cart:change events to open the cart drawer (no /cart redirect).
 *   5. Sleek-style scroll reveals (IntersectionObserver + air-home-motion.css),
 *      including reviving paused Replo alchemy-fade elements.
 * No external dependencies. Idempotent per element and per page.
 */
(function () {
  if (window.__airCproInit) return;
  window.__airCproInit = true;

  var TRANSITION = 'transform 450ms cubic-bezier(0.22, 0.61, 0.36, 1)';
  var REVEAL_OPTS = { rootMargin: '0px 0px -8% 0px', threshold: 0.15 };
  var STAGGER_MS = 80;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function currentX(track) {
    var m = /translate3d\(\s*(-?[\d.]+)px/.exec(track.style.transform || '');
    return m ? parseFloat(m[1]) : 0;
  }

  /* ---------------------------------------------------------------- carousels */
  function initCarousel(root) {
    if (window.AirCarousel && window.AirCarousel.init) {
      return window.AirCarousel.init(root);
    }
  }

  /* -------------------------------------------------------------- collapsibles */
  function initCollapsible(root) {
    if (root.__airCollapsible) return;
    root.__airCollapsible = true;
    var trigger = root.querySelector('[aria-controls]');
    if (!trigger) return;
    var contentId = trigger.getAttribute('aria-controls');
    var content = contentId ? document.getElementById(contentId) : null;
    function set(open) {
      root.setAttribute('data-state', open ? 'open' : 'closed');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (content) {
        if (open) content.removeAttribute('hidden');
        else content.setAttribute('hidden', '');
        content.setAttribute('data-state', open ? 'open' : 'closed');
      }
    }
    var toggle = function (e) {
      if (e) e.preventDefault();
      set(root.getAttribute('data-state') !== 'open');
    };
    trigger.addEventListener('click', toggle);
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') toggle(e);
    });
  }

  /* ------------------------------------------------- variants + add to cart */
  var VARIANTS = (function () {
    try {
      var el = document.getElementById('air-cpro-variants');
      return el ? JSON.parse(el.textContent) : [];
    } catch (e) { return []; }
  })();

  function matchVariant(values) {
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      var ok = true;
      for (var p = 0; p < values.length; p++) {
        var want = values[p];
        if (want == null) continue;
        var have = v['o' + (p + 1)];
        if (String(have || '').trim().toLowerCase() !== String(want).trim().toLowerCase()) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function containerOf(el) {
    return el.closest('[data-replo-product-container]') || document;
  }
  function formOf(scope) {
    return (scope.querySelector ? scope : document).querySelector('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
  }

  function initOptionSelect(listbox) {
    if (listbox.__airOpt) return;
    listbox.__airOpt = true;
    var options = Array.prototype.slice.call(listbox.querySelectorAll('[role="option"]'));
    if (!options.length) return;
    var container = containerOf(listbox);
    var initSel =
      options.filter(function (o) {
        return o.getAttribute('aria-selected') === 'true';
      })[0] || options[0];
    // Replo bakes the selected value into a separate "LABEL: VALUE" text element
    // (the "SIZE:"/"COLOUR:" prefix lives in one node, the value —
    // {{ reploSelectedVariant.optionN }} — in a sibling). That value node is
    // static after render, so the label never tracks client-side selection.
    // Find it by matching the initially-selected option's own (localized) text
    // against the .alchemy-rte text nodes outside every listbox, so this stays
    // locale- and option-name-independent (works for SIZE, COLOUR, etc.).
    var initLabel = (initSel.textContent || '').trim();
    var valueEl = null;
    if (initLabel && container && container.querySelectorAll) {
      var candidates = container.querySelectorAll('.alchemy-rte');
      for (var ci = 0; ci < candidates.length; ci++) {
        var cand = candidates[ci];
        if (cand.closest('[role="listbox"]')) continue;
        if ((cand.textContent || '').trim() === initLabel) {
          valueEl = cand;
          break;
        }
      }
    }
    function setValueLabel(text) {
      if (!valueEl) return;
      var leaf = valueEl;
      while (leaf.children && leaf.children.length === 1) leaf = leaf.children[0];
      leaf.textContent = text;
    }
    function select(opt) {
      options.forEach(function (o) {
        var on = o === opt;
        o.setAttribute('aria-selected', on ? 'true' : 'false');
        o.classList.toggle('r-9ai6a9', on);
      });
      var label = (opt.textContent || '').trim();
      setValueLabel(label);
      var v = matchVariant([label]);
      if (v) {
        var form = formOf(container);
        if (form) {
          var idInput = form.querySelector('input[name="id"]');
          if (idInput) idInput.value = v.id;
        }
        if (window.AirSoldOut) window.AirSoldOut.syncContainer(container);
      }
    }
    options.forEach(function (opt) {
      var handler = function (e) { if (e) e.preventDefault(); select(opt); };
      opt.addEventListener('click', handler);
      opt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') handler(e);
      });
      if (opt.getAttribute('aria-selected') === 'true') select(opt);
    });
  }

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Impact theme: bundle sections, dispatch variant:add + cart:change, open cart-drawer. */
  function dispatchCartAdded(responseJson, cartContent) {
    cartContent.sections = responseJson.sections;
    var items = responseJson.items || [responseJson];
    document.documentElement.dispatchEvent(
      new CustomEvent('variant:add', { bubbles: true, detail: { items: items, cart: cartContent } })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart: cartContent },
      })
    );
    openCartFallback();
  }

  function openCartFallback() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') {
      var cartType =
        window.themeVariables &&
        window.themeVariables.settings &&
        window.themeVariables.settings.cartType;
      if (cartType !== 'drawer') {
        try { drawer.show(); } catch (e) {}
      }
      return;
    }
    var legacy = document.querySelector('#CartDrawer, .js-drawer--cart');
    if (!legacy) return;
    var opener = document.querySelector('[aria-controls="cart-drawer"]');
    if (opener) opener.click();
  }

  function submitFormFallback(form) {
    if (!form) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  }

  function addVariantToCart(body, busyEl, form) {
    if (busyEl) busyEl.setAttribute('aria-busy', 'true');
    var sectionsToBundle = ['variant-added'];
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );
    } catch (e) {}
    var payload = {
      id: body.id,
      quantity: body.quantity || 1,
      sections: sectionsToBundle.join(','),
      sections_url: routeRoot() + 'variants/' + body.id,
    };
    if (body.selling_plan) payload.selling_plan = body.selling_plan;
    return fetch(routeRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (busyEl) busyEl.removeAttribute('aria-busy');
        if (!res.ok) {
          submitFormFallback(form);
          return;
        }
        return fetch(routeRoot() + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cartContent) { dispatchCartAdded(res.d, cartContent); });
      })
      .catch(function () {
        if (busyEl) busyEl.removeAttribute('aria-busy');
        submitFormFallback(form);
      });
  }

  function initAddToCart(btn) {
    if (btn.__airAtc) return;
    btn.__airAtc = true;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.getAttribute('aria-disabled') === 'true') return;
      var container = containerOf(btn);
      var form = formOf(container);
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      var body = {
        id: idInput && idInput.value,
        quantity: (qtyInput && parseInt(qtyInput.value, 10)) || 1,
      };
      var sp = form.querySelector('input[name="selling_plan"]');
      if (sp && sp.value) body.selling_plan = sp.value;
      if (!body.id) {
        submitFormFallback(form);
        return;
      }
      addVariantToCart(body, btn, form);
    });
  }

  /* --------------------------------------------------------------- size chart *
   * Buy-box "Size Chart" link -> modal built from the hidden PRO source        *
   * (air-cpro-size-chart-source). Replo opened this popup from section         *
   * settings at runtime; the conversion only kept the trigger. Bound by the    *
   * stable data-rid of the role="button" wrapper — locale-independent.         */
  var SIZE_CHART_TRIGGER_RIDS = ['64333cb9-d52d-4827-b904-335bf3c7ce50'];
  var sizeChartModal = null;
  var sizeChartLastFocus = null;

  function closeSizeChart() {
    if (!sizeChartModal || sizeChartModal.getAttribute('hidden') !== null) return;
    sizeChartModal.classList.remove('is-open');
    document.documentElement.classList.remove('air-cpro-modal-open');
    document.body.classList.remove('air-cpro-modal-open');
    var overlay = sizeChartModal;
    window.setTimeout(function () { overlay.setAttribute('hidden', ''); }, 220);
    if (sizeChartLastFocus && typeof sizeChartLastFocus.focus === 'function') {
      try { sizeChartLastFocus.focus(); } catch (e) {}
    }
  }

  function openSizeChart() {
    if (!sizeChartModal) return;
    sizeChartLastFocus = document.activeElement;
    sizeChartModal.removeAttribute('hidden');
    void sizeChartModal.offsetWidth;
    sizeChartModal.classList.add('is-open');
    document.documentElement.classList.add('air-cpro-modal-open');
    document.body.classList.add('air-cpro-modal-open');
    var closeBtn = sizeChartModal.querySelector('.air-cpro-sizechart-modal__close');
    if (closeBtn) { try { closeBtn.focus(); } catch (e) {} }
  }

  function initUnitToggle(scope) {
    var tabs = Array.prototype.slice.call(scope.querySelectorAll('[data-air-unit]'));
    var tables = Array.prototype.slice.call(scope.querySelectorAll('[data-air-unit-table]'));
    if (!tabs.length || !tables.length) return;
    function show(unit) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-air-unit') === unit;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      tables.forEach(function (tb) {
        if (tb.getAttribute('data-air-unit-table') === unit) tb.removeAttribute('hidden');
        else tb.setAttribute('hidden', '');
      });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        if (e) e.preventDefault();
        show(t.getAttribute('data-air-unit'));
      });
    });
  }

  function buildSizeChartModal(source) {
    var clone = source.cloneNode(true);
    clone.removeAttribute('id');
    clone.removeAttribute('hidden');
    clone.removeAttribute('aria-hidden');
    // Re-tag: the source class / data-attr is hidden with display:none !important
    // to keep the on-page template invisible. Drop them on the clone so the
    // overlay content actually renders, and swap in a distinct visible class.
    clone.removeAttribute('data-air-size-chart-source');
    clone.classList.remove('air-cpro-sizechart-source');
    clone.classList.add('air-cpro-size-chart-clone');
    clone.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });

    var overlay = document.createElement('div');
    overlay.className = 'air-cpro-sizechart-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Size chart');
    overlay.setAttribute('hidden', '');

    var dialog = document.createElement('div');
    dialog.className = 'air-cpro-sizechart-modal__dialog';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'air-cpro-sizechart-modal__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '&times;';

    dialog.appendChild(closeBtn);
    dialog.appendChild(clone);
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);

    closeBtn.addEventListener('click', function (e) { e.preventDefault(); closeSizeChart(); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeSizeChart(); });
    initUnitToggle(clone);

    return overlay;
  }

  function findSizeChartTriggers() {
    var seen = [];
    var triggers = [];
    SIZE_CHART_TRIGGER_RIDS.forEach(function (rid) {
      document.querySelectorAll('[data-rid="' + rid + '"]').forEach(function (el) {
        var trigger =
          el.getAttribute('role') === 'button' ? el : el.closest('[role="button"]') || el;
        if (seen.indexOf(trigger) === -1) { seen.push(trigger); triggers.push(trigger); }
      });
    });
    return triggers;
  }

  function initSizeChart() {
    try {
      var triggers = findSizeChartTriggers();
      if (!triggers.length) return;
      var open = function (e) {
        if (e) e.preventDefault();
        if (!sizeChartModal) {
          var source = document.querySelector('[data-air-size-chart-source]');
          if (!source) return;
          sizeChartModal = buildSizeChartModal(source);
        }
        openSizeChart();
      };
      triggers.forEach(function (trigger) {
        if (trigger.__airSizeChart) return;
        trigger.__airSizeChart = true;
        trigger.style.cursor = 'pointer';
        trigger.addEventListener('click', open);
        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') open(e);
        });
      });
    } catch (e) {}
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (sizeChartModal && sizeChartModal.getAttribute('hidden') === null) closeSizeChart();
  });

  /* ------------------------------------------------------------------ reveals */
  function hasAlchemyPaused(el) {
    var cs = getComputedStyle(el);
    return cs.animationName && cs.animationName.indexOf('alchemy') !== -1 && cs.animationPlayState === 'paused';
  }
  function hasBackgroundImage(el) {
    if ((el.style.backgroundImage || '').indexOf('url') !== -1) return true;
    var cs = getComputedStyle(el);
    return cs.backgroundImage && cs.backgroundImage !== 'none';
  }
  function isInView(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.top < vh * 0.92 && r.bottom > 0;
  }
  function revealEl(el) {
    if (el.__airRevealed) return;
    el.__airRevealed = true;
    el.classList.remove('air-reveal-pending');
    el.classList.add('air-reveal-visible');
  }
  function tagReveal(el, variant, delayMs) {
    if (el.__airRevealTagged) return null;
    el.__airRevealTagged = true;
    el.setAttribute('data-air-reveal', variant || 'fade-up');
    if (delayMs) el.style.setProperty('--air-reveal-delay', delayMs + 'ms');
    el.classList.add('air-reveal-pending', 'air-reveal--' + (variant || 'fade-up'));
    if (reducedMotion || isInView(el)) { revealEl(el); return null; }
    return el;
  }

  function initMotion() {
    var toObserve = [];
    var alchemyBg = [];
    function observe(el) { if (el && !el.__airRevealed) toObserve.push(el); }

    document.querySelectorAll('[id^="replo-section-"]').forEach(function (section) {
      section.querySelectorAll('[data-replo-carousel]').forEach(function (carousel) {
        if (hasAlchemyPaused(carousel) && hasBackgroundImage(carousel)) { alchemyBg.push(carousel); return; }
        observe(tagReveal(carousel, 'fade-up', 0));
      });
    });

    var nodes = document.querySelectorAll('[id^="replo-section-"] [data-rid]');
    var gi = 0;
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.__airRevealTagged || node.closest('[data-replo-carousel]')) continue;
      if (!hasAlchemyPaused(node)) continue;
      if (hasBackgroundImage(node)) { alchemyBg.push(node); continue; }
      node.classList.add('air-reveal--alchemy-override');
      observe(tagReveal(node, 'fade-up', (gi++ % 6) * STAGGER_MS));
    }

    function playAlchemy(el) { el.style.animationPlayState = 'running'; }
    if (alchemyBg.length) {
      if (!('IntersectionObserver' in window) || reducedMotion) {
        alchemyBg.forEach(playAlchemy);
      } else {
        var aio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { playAlchemy(e.target); aio.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -5% 0px', threshold: 0.01 });
        alchemyBg.forEach(function (el) { if (isInView(el)) playAlchemy(el); else aio.observe(el); });
      }
    }

    if (!toObserve.length) return;
    if (reducedMotion || !('IntersectionObserver' in window)) { toObserve.forEach(revealEl); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { revealEl(e.target); io.unobserve(e.target); } });
    }, REVEAL_OPTS);
    toObserve.forEach(function (el) { if (isInView(el)) revealEl(el); else io.observe(el); });
  }

  ready(function () {
    document.querySelectorAll('[data-replo-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-replo-collapsible]').forEach(initCollapsible);
    document.querySelectorAll('[data-replo-option-select]').forEach(initOptionSelect);
    document.querySelectorAll('[data-replo-add-product-variant-to-cart]').forEach(initAddToCart);
    initSizeChart();
    initMotion();
  });
})();
